import React, { useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import VentasReportePanel from "../../components/VentasReportePanel";

const TABS = [
  { key: "generales", label: "Ventas generales" },
  { key: "promocionales", label: "Ventas promocionales" },
];

export function ReportesPage() {
  const [tab, setTab] = useState("generales");

  return (
    <div className="w-full p-content pb-16 min-h-[400px]">
      <div className="flex w-full justify-end items-center gap-4 mb-6">
        <button
          type="button"
          className="bg-pink text-white py-2 px-8 font-bold rounded-full flex justify-center items-center"
          onClick={() => {
            window.location.href = "/inventario";
          }}
        >
          <IoMdArrowRoundBack className="text-lg mr-1" /> Volver
        </button>
      </div>

      <p className="text-2xl font-bold mb-2">Reportes</p>
      <p className="text-sm text-gray-500 mb-6">Generá y descargá reportes de ventas por período.</p>

      <div className="flex border-b border-gray-200 mb-8">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`px-6 py-3 text-sm font-semibold border-b-2 transition-colors ${
              tab === t.key ? "border-purple text-purple" : "border-transparent text-gray-500 hover:text-purple"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "generales" && (
        <div>
          <p className="text-2xl font-bold mb-2">Reporte de ventas</p>
          <VentasReportePanel
            reportBase="reportes/ventas"
            description="Descargá un archivo Excel con todas las líneas de venta del período seleccionado (con o sin descuento)."
            emptyMessage="No hay ventas en el período seleccionado."
            downloadFilenamePrefix="reporte-ventas"
            previewCountSuffix={{ singular: "línea de venta", plural: "líneas de venta" }}
          />
        </div>
      )}

      {tab === "promocionales" && (
        <div>
          <p className="text-2xl font-bold mb-2">Reporte de Ventas Promocionales</p>
          <VentasReportePanel
            reportBase="reportes/ventas-promocionales"
            description="Descargá un archivo Excel con las ventas de productos que tuvieron descuento activo en el período seleccionado."
            emptyMessage="No hay ventas promocionales en el período seleccionado."
            downloadFilenamePrefix="reporte-ventas-promocionales"
            previewCountSuffix={{ singular: "línea de producto con descuento", plural: "líneas de producto con descuento" }}
          />
        </div>
      )}
    </div>
  );
}

export default ReportesPage;
